import { Controller, RegisterOptions, useFormContext } from "react-hook-form";
import TextInput from "./TextInput";
import React from "react";

interface FormTextInputProps {
  name: string;
  placeholder: string;
  label?: string;
  description?: string;
  type?: string;
  rules?: RegisterOptions;
  disabled?: boolean;
  extraType?: "alfanumeric" | "alfanumericNoSpaces" | "numeric" | "text" | "plate";
}

// El `name` que llega al DOM no lo usa nadie para leer el valor (lo maneja react-hook-form por el
// Controller) y Chrome lo lee para clasificar el campo: uno como "transportNumeroRemito" lo hace
// pasar por número de tarjeta. El wrapper conserva el nombre real en `data-field-name`, que es
// por donde se ubica el campo (ver findFieldElement en fieldLabelMap.ts).
const opaqueDomName = (name: string): string => {
  let hash = 5381;
  for (let i = 0; i < name.length; i++) hash = ((hash << 5) + hash + name.charCodeAt(i)) | 0;
  return `fld-${(hash >>> 0).toString(36)}`;
};

const FormTextInput = ({
  name,
  placeholder,
  label,
  description,
  type,
  rules,
  disabled,
  extraType,
}: FormTextInputProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <div data-field-name={name} style={{ width: "100%" }}>
          <TextInput
            name={opaqueDomName(name)}
            placeholder={placeholder}
            label={label}
            value={field.value}
            onChange={field.onChange}
            onBlur={field.onBlur}
            description={description}
            type={type}
            extraType={extraType}
            error={fieldState.error?.message}
            disabled={disabled}
          />
        </div>
      )}
    />
  );
};

export default FormTextInput;
